import { OrganType } from '@nkr/enums/organ-type';
import { IBaseResponse } from '@nkr/models/index';
import { IObjectResponse, IArrayResponse } from "@nkr/store/application";
import { AuthActionCreators } from "@nkr/store/authorization";
import { IApplicationState } from "@nkr/store/index"
import { Dispatch } from "react-redux";

export interface IInvoiceSummary {
    centerId: number,
    centerAlias: string,
    organType: number,
    id: number,
    invoiceNumber: number,
    amountDue: number,
    amountPaid: number,
    balanceDue: number,
    invoiceDate: string,
    dueDate: string,
    daysDelinquent: number,
    stopLateNoticesUntil: string
}

export interface IInvoicePayment {
    id: number,
    invoiceId: number,
    paymentDate: string,
    recordedDateTime: string,
    paymentType: string,
    checkNumber: number,
    amount: number
}

export const ActionsAdminInvoice = {
    getCollections: (isPaid: boolean, organType: OrganType, paidStartDate: string, paidEndDate: string) => (dispatch: Dispatch<IApplicationState>): Promise<IArrayResponse<IInvoiceSummary>> => {
        let options = {
            url: `${__API__}/invoice/collections?isPaid=${isPaid}&organType=${organType}&paidStart=${paidStartDate}&paidEnd=${paidEndDate}`
        };

        return dispatch(AuthActionCreators.apiGet(options)).then((response: IArrayResponse<IInvoiceSummary>) => {
            return Promise.resolve(response);
        });
    },

    getPayments: (invoiceId: number) => (dispatch: Dispatch<IApplicationState>): Promise<IArrayResponse<IInvoicePayment>> => {
        let options = {
            url: `${__API__}/invoice/${invoiceId}/payment`
        };

        return dispatch(AuthActionCreators.apiGet(options)).then((response: IArrayResponse<IInvoicePayment>) => {
            return Promise.resolve(response);
        });
    },

    addPayment: (payment: IInvoicePayment) => (dispatch: Dispatch<IApplicationState>): Promise<IObjectResponse<IInvoicePayment>> => {
        let options = {
            url: `${__API__}/invoice/${payment.invoiceId}/payment`,
            data: payment
        };

        return dispatch(AuthActionCreators.apiPost(options)).then((response: IObjectResponse<IInvoicePayment>) => {
            return Promise.resolve(response);
        });
    },

    removePayment: (payment: IInvoicePayment) => (dispatch: Dispatch<IApplicationState>): Promise<IBaseResponse> => {
        let options = {
            url: `${__API__}/invoice/${payment.invoiceId}/payment/${payment.id}`
        };

        return dispatch(AuthActionCreators.apiDelete(options)).then((response: IBaseResponse) => {
            return Promise.resolve(response);
        });
    },

    stopNotices: (invoice: IInvoiceSummary) => (dispatch: Dispatch<IApplicationState>): Promise<IBaseResponse> => {
        let options = {
            url: `${__API__}/invoice/${invoice.id}/stop-notices`,
            data: invoice
        };

        return dispatch(AuthActionCreators.apiPut(options)).then((response: IBaseResponse) => {
            return Promise.resolve(response);
        });
    }
};